import image from "./assets/home.jpg";

export const Home: React.FC = () => {
  return <img src={image} style={{ width: "100%" }} alt="" />;
};
